import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { url } from '../../../constants/routes';
import { connect } from '../../../reducers/index';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';
// import AssistGraphic from '../img/assist-graphic.svg';
// import AssistGraphic02 from '../img/assist-prof-holding-map-graphic.svg';

const AssistPage = props => {
  const questions = {
    //title: 'Question 3: Asking Directly',
    type: 'single',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`When you think someone may be experiencing a mental health challenge, what is the best way to bring up your concerns with them? select one`}
        />
        <strong>
          When you think someone may be experiencing a mental health challenge, what is the best way to bring up your concerns with them?
        </strong>
        <br />
        (select one)
      </Fragment>
    ),
    result: ['D'],
    feedback: {
      correctNode:
        <div>
          <p>Correct! Being direct about your concerns and highlighting things you notice is an effective way of engaging in a meaningful and honest conversation with someone you’re concerned about. Explicitly but politely naming the things you notice as reasons for wanting to check in with someone, communicates that you care and that you are willing to listen and talk openly about the challenges they may be experiencing. This invites the person to speak specifically to the indicators you identified and may help them realize that their struggle is not going unnoticed.</p>
          <p>Answer options A, B and C have limitations. Valuing privacy is important, but it shouldn’t deter you from checking in on someone you’re concerned about, even if it feels uncomfortable to do so. Remember, you can respect what they share with you by treating it with sensitivity and discretion.</p>
          <p>While it’s helpful practice to let people know you’re available to listen, it doesn’t necessarily let someone know that you’d be comfortable talking about potentially uncomfortable subjects. This approach also puts the onus on the other person to bring up what might be a difficult subject for them.</p>
          <p>Asking “How things are going?” is a useful way to begin a conversation but because it’s so general, and something we’re asked all the time, it is less likely to lead to someone opening up about the challenges they may be experiencing. Asking about someone's behaviours, thoughts, and feelings in a more direct way can enable them to answer with more specificity and honesty.</p>
        </div>,
      correct:
        <div>
          <p>Correct! Being direct about your concerns and highlighting things you notice is an effective way of engaging in a meaningful and honest conversation with someone you’re concerned about. Explicitly but politely naming the things you notice as reasons for wanting to check in with someone, communicates that you care and that you are willing to listen and talk openly about the challenges they may be experiencing. This invites the person to speak specifically to the indicators you identified and may help them realize that their struggle is not going unnoticed.</p>
          <p>Answer options A, B and C have limitations. Valuing privacy is important, but it shouldn’t deter you from checking in on someone you’re concerned about, even if it feels uncomfortable to do so. Remember, you can respect what they share with you by treating it with sensitivity and discretion.</p>
          <p>While it’s helpful practice to let people know you’re available to listen, it doesn’t necessarily let someone know that you’d be comfortable talking about potentially uncomfortable subjects. This approach also puts the onus on the other person to bring up what might be a difficult subject for them.</p>
          <p>Asking “How things are going?” is a useful way to begin a conversation but because it’s so general, and something we’re asked all the time, it is less likely to lead to someone opening up about the challenges they may be experiencing. Asking about someone's behaviours, thoughts, and feelings in a more direct way can enable them to answer with more specificity and honesty.</p>
        </div>,
      incorrect: '',
      all: ''
    }
  };
  const options = [
    {
      prefix: 'A',
      result: 'incorrect',
      optionText:
        'Don’t raise your concern. Respect their right to privacy and let them approach you if they would like your support',
      resultText:
          <div><p>The correct answer is D. Being direct about your concerns and highlighting things you notice is an effective way
          of engaging in a meaningful and honest conversation with someone you’re concerned about. Explicitly but politely
          naming the things you notice as reasons for wanting to check in with someone, communicates that you care and that
          you are willing to listen and talk openly about the challenges they may be experiencing. This invites the person to
          speak specifically to the indicators you identified and may help them realize that their struggle is not going unnoticed.</p>
          <p>Answer options A, B and C have limitations. Valuing privacy is important, but it shouldn’t deter you
          from checking in on someone you’re concerned about, even if it feels uncomfortable to do so. Remember, you
          can respect what they share with you by treating it with sensitivity and discretion.</p>
          <p>While it’s helpful practice to let people know you’re available to listen, it doesn’t necessarily let someone
            know that you’d be comfortable talking about potentially uncomfortable subjects. This approach also puts the onus
            on the other person to bring up what might be a difficult subject for them.</p>
          <p>Asking 'How are things going?' is a useful way to begin a conversation but because it’s so general, and something
          we’re asked all the time, it is less likely to lead to someone opening up about the challenges they may be experiencing.
          Asking about someone's behaviours, thoughts, and feelings in a more direct way can enable them to answer with more specificity and honesty.</p>
        </div>
    },
    {
      prefix: 'B',
      result: 'incorrect',
      optionText:
        'Let the person know that you are available if they ever want to talk.',
      resultText:
        <div>
          <p>The correct answer is D. Being direct about your concerns and highlighting things you notice is an effective way of engaging in a meaningful and honest conversation with someone you’re concerned about. Explicitly but politely naming the things you notice as reasons for wanting to check in with someone, communicates that you care and that you are willing to listen and talk openly about the challenges they may be experiencing. This invites the person to speak specifically to the indicators you identified and may help them realize that their struggle is not going unnoticed.</p>
          <p>Answer options A, B and C have limitations. Valuing privacy is important, but it shouldn’t deter you from checking in on someone you’re concerned about, even if it feels uncomfortable to do so. Remember, you can respect what they share with you by treating it with sensitivity and discretion.</p>
          <p>While it’s helpful practice to let people know you’re available to listen, it doesn’t necessarily let someone know that you’d be comfortable talking about potentially uncomfortable subjects. This approach also puts the onus on the other person to bring up what might be a difficult subject for them.</p>
          <p>Asking “How things are going?” is a useful way to begin a conversation but because it’s so general, and something we’re asked all the time, it is less likely to lead to someone opening up about the challenges they may be experiencing. Asking about someone's behaviours, thoughts, and feelings in a more direct way can enable them to answer with more specificity and honesty.</p>
        </div>
    },
    {
      prefix: 'C',
      result: 'incorrect',
      optionText: 'Do a general check-in by asking “How are things going?”',
      resultText:
        <div>
          <p>The correct answer is D. Being direct about your concerns and highlighting things you notice is an effective way of engaging in a meaningful and honest conversation with someone you’re concerned about. Explicitly but politely naming the things you notice as reasons for wanting to check in with someone, communicates that you care and that you are willing to listen and talk openly about the challenges they may be experiencing. This invites the person to speak specifically to the indicators you identified and may help them realize that their struggle is not going unnoticed.</p>
          <p>Answer options A, B and C have limitations. Valuing privacy is important, but it shouldn’t deter you from checking in on someone you’re concerned about, even if it feels uncomfortable to do so. Remember, you can respect what they share with you by treating it with sensitivity and discretion.</p>
          <p>While it’s helpful practice to let people know you’re available to listen, it doesn’t necessarily let someone know that you’d be comfortable talking about potentially uncomfortable subjects. This approach also puts the onus on the other person to bring up what might be a difficult subject for them.</p>
          <p>Asking “How things are going?” is a useful way to begin a conversation but because it’s so general, and something we’re asked all the time, it is less likely to lead to someone opening up about the challenges they may be experiencing. Asking about someone's behaviours, thoughts, and feelings in a more direct way can enable them to answer with more specificity and honesty.</p>

        </div>
    },
    {
      prefix: 'D',
      result: 'correct',
      optionText:
        'Share with them the things you identified for being concerned and ask them if everything is okay.'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={2}
      childTitle="Assist"
      progressType="assist"
      nextRotue={url.ASSIST_B}
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text={`ASSIST: How to assist someone experiencing a mental health challenge`} />
              <h2 className="txt-green no-bold no-margin">
                ASSIST: How to Assist Someone Experiencing a Mental Health Challenge
              </h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader
                text={`When you identify that someone is experiencing a mental 
                health challenge, the next step is to engage them in a conversation 
                to better understand their needs. With this understanding, you will 
                be able to identify and refer them to helpful and tailored resources 
                and services. Work through the following question 
                to learn how to begin a supportive conversation.`}
              />
              <p>
                When you identify that someone is experiencing a mental
                health challenge, the next step is to engage them in a conversation
                to better understand their needs. With this understanding, you will 
		be able to identify and refer them to helpful and tailored resources 
		and services. Work through the following question
                to learn how to begin a supportive conversation.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="assist"
        nextRoute={url.ASSIST_C}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

AssistPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const AssistA = connect.role(AssistPage);

export default AssistA;



// WEBPACK FOOTER //
// ./src/containers/Assist/AssistB/index.jsx